var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as R from "ramda";
import { getRequestArgs } from "./getRequestArgs.mjs";
import { ALL, CATEGORY_SCHEME } from "./constants/types.mjs";
const getArtefactsListRequestArgs = (_a) => {
  var _b = _a, {
    category,
    type,
    agencyId,
    version
  } = _b, rest = __objRest(_b, [
    "category",
    "type",
    "agencyId",
    "version"
  ]);
  return R.pipe(
    R.ifElse(
      R.isNil,
      R.always({
        identifiers: { agencyId, code: ALL, version },
        type,
        withReferences: false
      }),
      R.always({
        identifiers: __spreadProps(__spreadValues({}, R.propOr({}, "scheme", category)), {
          subcode: R.prop("hierarchicalCode", category)
        }),
        params: { references: type },
        type: CATEGORY_SCHEME
      })
    ),
    R.mergeRight(R.assoc("overview", true, rest)),
    getRequestArgs,
    R.assoc("parsing", {
      space: rest.datasource,
      type,
      agencyIds: R.propOr([], "agencyIds", rest),
      fromCategory: !R.isNil(category)
    })
  )(category);
};
export {
  getArtefactsListRequestArgs
};
